import { render, staticRenderFns } from "./ourValues.vue?vue&type=template&id=0ab4679a"
import script from "./ourValues.vue?vue&type=script&lang=js"
export * from "./ourValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports